import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Component
import TextInput from '../TextInput';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

// Queries
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';

export default function AddById({
  screenSize,
  webservice,
  getCookie,
  addedArray,
  setAddedArray,
  setOrderData,
  setSessionMessage,
}) {
  const [productID, setProductID] = useState('');
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarState, setSnacsnackbarStatekbar] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'right',
    severity: 'error',
  });

  const { t } = useTranslation('products');

  const { vertical, horizontal, open, severity } = snackbarState;

  const handleClose = () => {
    setSnacsnackbarStatekbar({ ...snackbarState, open: false });
  };

  async function handleSubmit(e) {
    setLoading(true);

    const order = await postGlobal({
      tmbservice: 'getAgregarAlCarrito',
      jsonBody: {
        accion: 'ORDENAR',
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        almacen: getCookie('warehouse'),
        categoria: 0,
        caller: 'consultarCart',
        clave: productID,
        cantidad: quantity,
        numeroLinea: '',
        textoProdSeleccion: '',
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
        origen: 'CARRITONUE',
      },
    });

    const { tipoMensaje = 'error', mensaje = '' } = order;

    setSessionMessage(mensaje);

    if (tipoMensaje === 'exito') {
      if (setAddedArray) {
        setAddedArray((oldArray) => {
          return [...oldArray, productID];
        });
      } else {
        setErrorMessage('Product added');
        setSnacsnackbarStatekbar({
          open: true,
          vertical: 'top',
          horizontal: 'right',
          severity: 'success',
        });
      }

      setOrderData(order);
    } else {
      setErrorMessage(order?.mensaje || '');
      setSnacsnackbarStatekbar({
        open: true,
        vertical: 'top',
        horizontal: 'right',
        severity: 'error',
      });
    }

    setLoading(false);
  }
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!loading) handleSubmit(e);
      }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        key={vertical + horizontal}>
        <MuiAlert severity={severity} variant='filled'>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
      <div className={`${styles.addById} ${styles[screenSize]}`}>
        <div className={`${styles.column} ${styles.titleContainer}`}>
          <i className='material-icons-outlined'>add_shopping_cart</i>
          <span className={styles.title}>{t('addByIdText')}:</span>
        </div>
        <div className={`${styles.column} ${styles.inputContainer}`}>
          <TextInput
            type='text'
            value={productID}
            onChange={setProductID}
            name='productID'
            placeholder={t('keyPlaceholder')}
          />
        </div>
        <div className={`${styles.column} ${styles.inputContainer}`}>
          <TextInput
            type='number'
            value={quantity}
            onChange={setQuantity}
            name='quantity'
            placeholder={t('quantityPlaceholder')}
          />
        </div>
        <div className={`${styles.column} ${styles.buttonContainer}`}>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={styles.button}>
            {(loading && <CircularProgress className={styles.circularProgress} />) ||
              t('addByIdButton')}
          </Button>
        </div>
      </div>
    </form>
  );
}
